import { render, staticRenderFns } from "./WeekPlan.vue?vue&type=template&id=5778db46&"
import script from "./WeekPlan.vue?vue&type=script&lang=ts&"
export * from "./WeekPlan.vue?vue&type=script&lang=ts&"
import style0 from "./WeekPlan.vue?vue&type=style&index=0&id=5778db46&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports